import { connect } from 'react-redux'

import {
  setAddress,
  updateAddressFinance,
} from 'reduxpath/ducks/Profile/Detail'

import FinanceProfileSection from './units'

const mapStateToProps = state => ({
  dataFinance: state.ProfileDetail.financeProfile.rows[0],
  isLoading: state.ProfileDetail.isLoading,
  isUpdated: state.ProfileDetail.isUpdated,
  isUpdatedError: state.ProfileDetail.isUpdatedError,
})

const mapDispatchToProps = dispatch => ({
  onChangeAddress(e) {
    const inputAddress = e.target.value
    dispatch(setAddress(inputAddress))
  },

  onSaveAddress(id, address) {
    return () => {
      dispatch(updateAddressFinance(id, {
        address,
      }))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(FinanceProfileSection)
